/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  autofocus: Boolean,
  autosize: {
    type: [Boolean, Object],
    "default": false
  },
  disabled: Boolean,
  maxcharacter: {
    type: Number
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    "default": ""
  },
  placeholder: {
    type: String,
    "default": void 0
  },
  readonly: Boolean,
  status: {
    type: String,
    validator: function validator(val) {
      return ["success", "warning", "error"].includes(val);
    }
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: [String, Number]
  },
  defaultValue: {
    type: [String, Number]
  },
  onBlur: Function,
  onChange: Function,
  onFocus: Function,
  onKeydown: Function,
  onKeypress: Function,
  onKeyup: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
